define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var CustomerDocumentModel = /** @class */ (function () {
        function CustomerDocumentModel(data) {
            this.Id = ko.observable(0);
            this.CustomerId = ko.observable(0);
            this.CategoryId = ko.observable(0);
            this.ParentId = ko.observable(0);
            this.DocType = ko.observable(1);
            this.Description = ko.observable("");
            this.Name = ko.observable("");
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CustomerDocumentModel.Mapping, self);
            }
        }
        CustomerDocumentModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CustomerDocumentModel(options.data);
            }
        };
        return CustomerDocumentModel;
    }());
    return CustomerDocumentModel;
});
//# sourceMappingURL=CustomerDocumentModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CustomerDocumentModel.js
// module id = 168
// module chunks = 2